module.exports = __webpack_public_path__ + "media/images/syncError-2da2873b4204d37baf99f83e41173a3c.svg";